import { LoadableAfterPaint } from '@confluence/loadable';
import type { SatisfactionSurveyModalProps } from '../src/SatisfactionSurveyModal';

export const SatisfactionSurveyModal = LoadableAfterPaint<SatisfactionSurveyModalProps>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SatisfactionSurveyModal" */ '../src/SatisfactionSurveyModal'
			)
		).SatisfactionSurveyModal,
});
